import { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../../context/auth/AuthContext";
import LandLordContext from "../../../context/landlord/LandLordContext";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../../hooks/useTranslator";
import CreditsRow from "../../../components/credit-ledger/CreditsRow";
import { PageHeader, SkeletonTable } from "../../../components/design";
import "../../../components/Profiles/ProfileTable.css";
import "./CreditsTable.css";

const CreditsTable = () => {
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const { userType, loadMyNotifications } = authContext;

  const landLordContext = useContext(LandLordContext);
  const { loadCreditsLedgerData } = landLordContext;

  const [loading, setLoading] = useState(false);

  const [transactionHistory, setTransactionHistory] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [total, setTotal] = useState(0);
  const loadingRef = useRef(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async (requestedPage = page) => {
    if (loadingRef.current) return;
    loadingRef.current = true;

    setLoading(true);
    try {
      const response = await loadCreditsLedgerData({
        page: requestedPage,
        limit,
      });

      if (!response) {
        return;
      }

      const { data, total: newTotal } = response;

      setTotal(newTotal);
      setPage(requestedPage);

      setTransactionHistory((prev) =>
        requestedPage === 1 ? data : [...prev, ...data]
      );
      let userid = localStorage.getItem("saveduserid");
      loadMyNotifications(userid, userType);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      loadingRef.current = false;
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 500 &&
        !loadingRef.current &&
        transactionHistory.length < total
      ) {
        loadData(page + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    // On a tall screen one page may not fill the window, so no scroll event
    // ever fires. Load more only while the page cannot scroll at all.
    if (document.documentElement.scrollHeight <= window.innerHeight) {
      handleScroll();
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, total, transactionHistory]);

  return (
    <div className="main-page-wrapper mb-4 position-relative profileRequestWrapper">
      <PageHeader title={_t("creditsHistory")} />
      <div className="profile-table-card">
        <div className="profile-table-scroll">
          <table className="profile-table credits-table">
            <thead className="hideOnMobile">
              <tr>
                <th>{_t("transactionType", "Field in Credit ledger table")}</th>
                <th>{_t("credits", "Field in Credit ledger table")}</th>
                <th>{_t("amount", "Field in Credit ledger table")}</th>
                <th>
                  {_t("transactionStatus", "Field in Credit ledger table")}
                </th>
                <th>
                  {_t("profileOpenedRef", "Field in Credit ledger  table")}
                </th>
                <th>{_t("doneByLandlord", "Field in Credit ledger table")}</th>
                <th>{_t("transactionDate", "Field in Credit ledger table")}</th>
                <th className="credits-table__invoice">
                  {_t("downloadInvoice")}
                </th>
              </tr>
            </thead>
            <tbody>
              {(transactionHistory ?? []).map((data) => (
                <CreditsRow key={data?._id} data={data} />
              ))}
            </tbody>
          </table>
        </div>
        {loading ? (
          <SkeletonTable
            rows={6}
            columns={7}
            avatar={false}
            label={_t("loading")}
          />
        ) : (
          transactionHistory?.length === 0 && (
            <p className="credits-table__empty">
              {_t(
                "noTransactionsFound",
                "Used text if there is no transaction in landlord's ledger"
              )}
            </p>
          )
        )}
      </div>
    </div>
  );
};

export default CreditsTable;
